/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Modifiedbyid2Inputs */

const en_entity_modifiedbyid2 = /** @type {(inputs: Entity_Modifiedbyid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modified By ID`)
};

const de_entity_modifiedbyid2 = /** @type {(inputs: Entity_Modifiedbyid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert von ID`)
};

/**
* | output |
* | --- |
* | "Modified By ID" |
*
* @param {Entity_Modifiedbyid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_modifiedbyid2 = /** @type {((inputs?: Entity_Modifiedbyid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Modifiedbyid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_modifiedbyid2(inputs)
	return de_entity_modifiedbyid2(inputs)
});
export { entity_modifiedbyid2 as "entity_modifiedById" }